// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-iam-access-dialog-add-subjects__header {
  display: flex;
  align-items: center;
}
.dl-iam-access-dialog-add-subjects__title {
  margin-left: 10px;
}
.dl-iam-access-dialog-add-subjects__subjects-list {
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/IamAccessDialog/AddSubjects/AddSubjects.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,mBAAA;AAAR;AAGI;EACI,iBAAA;AADR;AAII;EACI,gBAAA;AAFR","sourcesContent":[".dl-iam-access-dialog-add-subjects__header {\n  display: flex;\n  align-items: center;\n}\n.dl-iam-access-dialog-add-subjects__title {\n  margin-left: 10px;\n}\n.dl-iam-access-dialog-add-subjects__subjects-list {\n  margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
